import { render, staticRenderFns } from "./PedidosList.vue?vue&type=template&id=538e7f94&"
import script from "./PedidosList.vue?vue&type=script&lang=js&"
export * from "./PedidosList.vue?vue&type=script&lang=js&"
import style0 from "./PedidosList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports